<template>
  <div class="credit-query-page">
    <el-card class="page-card">
      <div slot="header" class="card-header">
        <h2>信用查询(CA)</h2>
      </div>
      <div class="page-content">
        <el-form :model="form" label-width="100px" class="login-form">
          <el-form-item label="CertID">
            <el-select 
              v-model="form.certId" 
              placeholder="请选择证书"
              clearable
              style="width: 100%">
              <el-option
                v-for="cert in certList"
                :key="cert.certid"
                :label="cert.name"
                :value="cert.certid">
              </el-option>
            </el-select>
            <div style="margin-top: 10px;">
              <el-button 
                @click="initCertList" 
                :loading="isLoadingCert"
                :disabled="isLoadingCert"
                size="small">
                <i class="el-icon-refresh"></i> 刷新证书列表
              </el-button>
              <span v-if="isLoadingCert" class="loading-tip" style="margin-left: 10px;">
                <i class="el-icon-loading"></i> 正在获取证书列表...
              </span>
            </div>
          </el-form-item>
          <el-form-item label="PassWd">
            <el-input v-model="form.passWd" type="password" placeholder="请输入密码" clearable show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
            <el-button type="primary" @click="handleGetSymKey" :loading="loading">获取对称密钥</el-button>
          </el-form-item>
        </el-form>
        
        <!-- 非对称加解密（参考 demo: test_SOF_PriKeyDecrypt） -->
        <el-divider content-position="left">非对称加解密（Exchange证书）</el-divider>
        <el-form :model="asymForm" label-width="120px" class="encrypt-form">
          <el-form-item label="原文数据">
            <el-input 
              v-model="asymForm.plain" 
              type="textarea" 
              :rows="4"
              placeholder="请输入待加密的原文" 
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="加密证书/公钥">
            <el-input 
              v-model="asymForm.cert" 
              type="textarea" 
              :rows="4"
              placeholder="点击登录后会自动导出并填充用户加密证书(Exchange)" 
              clearable>
            </el-input>
            <div style="margin-top:10px;">
              <el-button type="primary" :loading="asymLoading.encrypt" @click="handleAsymEncrypt">公钥加密</el-button>
            </div>
          </el-form-item>
          <el-form-item label="加密后的密文">
            <el-input 
              v-model="asymForm.cipher" 
              type="textarea" 
              :rows="4"
              placeholder="公钥加密后的密文" 
              clearable>
            </el-input>
            <div style="margin-top:10px;">
              <el-checkbox v-model="asymForm.base64Out">Base64格式</el-checkbox>
              <el-button type="primary" style="margin-left:10px;" :loading="asymLoading.decrypt" @click="handleAsymDecrypt" >私钥解密</el-button>
            </div>
          </el-form-item>
          <el-form-item label="解密后的明文">
            <el-input 
              v-model="asymForm.decrypted" 
              type="textarea" 
              :rows="4"
              placeholder="私钥解密后的明文" 
              clearable>
            </el-input>
          </el-form-item>
        </el-form>
        
        <!-- 加密解密区域 -->
        <el-divider content-position="left">加密解密测试</el-divider>
        <el-form :model="encryptForm" label-width="120px" class="encrypt-form">
          <el-form-item label="对称密钥">
            <el-input 
              v-model="encryptForm.symKey" 
              placeholder="请输入或点击获取对称密钥" 
              clearable>
              <el-button 
                slot="append" 
                @click="handleFillSymKey" 
                :loading="loading">
                获取密钥
              </el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="原文数据1">
            <el-input 
              v-model="encryptForm.plainText" 
              type="textarea" 
              :rows="4"
              placeholder="请输入要加密的原文数据" 
              clearable>
            </el-input>
            <div style="margin-top: 10px;">
              <el-button type="primary" @click="handleEncrypt" :loading="encryptLoading" :disabled="!encryptForm.symKey || !encryptForm.plainText">加密</el-button>
            </div>
          </el-form-item>
          <el-form-item label="加密后的密文">
            <el-input 
              v-model="encryptForm.cipherText" 
              type="textarea" 
              :rows="4"
              placeholder="加密后的密文将显示在这里" 
              clearable>
            </el-input>
            <div style="margin-top: 10px;">
              <el-button type="primary" @click="handleDecrypt" :loading="decryptLoading">解密</el-button>
            </div>
          </el-form-item>
          <el-form-item label="解密后的明文">
            <el-input 
              v-model="encryptForm.decryptedText" 
              type="textarea" 
              :rows="4"
              placeholder="解密后的明文将显示在这里" 
              clearable>
            </el-input>
          </el-form-item>
        </el-form>
        
        <!-- 文件上传区域 -->
        <el-divider content-position="left">文件上传</el-divider>
        <div class="upload-section">
          <div class="upload-area">
            <el-button type="primary" icon="el-icon-upload2" @click="handleUploadDocument">本地上传</el-button>
            <div class="el-upload__tip">支持的文件类型：PDF、Word、图片等，单个文件不能超过10GB</div>
          </div>
          <div class="uploaded-files">
            <el-table :data="uploadedFiles" border style="width: 100%">
              <el-table-column prop="fileName" label="文件名称" min-width="200"></el-table-column>
              <el-table-column prop="uploadTime" label="上传时间" width="150"></el-table-column>
              <el-table-column prop="uploader" label="上传人" width="120"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handleDeleteFile(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-card>
    
    <!-- 文件上传进度对话框 -->
    <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" :show-close="false">
      <div class="upload-progress-content">
        <div class="upload-info">
          <i class="el-icon-upload" style="font-size: 24px; color: #409EFF; margin-right: 10px;"></i>
          <span>{{ uploadProgress.fileName }}</span>
        </div>
        <el-progress :percentage="uploadProgress.percentage"
          :status="uploadProgress.status === 'success' ? 'success' : (uploadProgress.status === 'error' ? 'exception' : null)"
          style="margin-top: 20px;">
        </el-progress>
        <div class="upload-status" style="margin-top: 10px; text-align: center;">
          <span v-if="uploadProgress.status === 'uploading'">正在上传...</span>
          <span v-else-if="uploadProgress.status === 'success'" style="color: #67C23A;">上传成功</span>
          <span v-else-if="uploadProgress.status === 'error'" style="color: #F56C6C;">上传失败</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { XTXASynObject } from '@/api/ca/XTXASynObject'
import { useStore } from '@/api/ca/store/index'
import { UPLOAD_CONSTANTS } from '@/utils/base'
import { doFileUpload } from '@/utils/fileUploadHelper'

export default {
  name: 'CreditQuery',
  data() {
    return {
      form: {
        certId: '',
        passWd: '111111'
      },
      loading: false,
      xtxObject: null,
      store: null,
      isLoadingCert: false,
      certList: [], // 证书列表
      certInfoArr:[],
      encryptForm: {
        symKey: '',
        plainText: '',
        cipherText: '',
        decryptedText: ''
      },
      encryptLoading: false,
      decryptLoading: false,
      // 非对称加解密表单
      asymForm: {
        cert: '',
        plain: '',
        cipher: '',
        decrypted: '',
        base64Out: false
      },
      asymLoading: {
        encrypt: false,
        decrypt: false
      },
      fileBindId: '', // 文件绑定ID
      uploadedFiles: [], // 已上传文件列表
      uploadProgress: {
        visible: false, // 是否显示上传进度弹窗
        percentage: 0, // 上传进度
        fileName: '', // 文件名称
        status: null // 上传状态
      }
    }
  },
  created() {
    this.xtxObject = new XTXASynObject()
    this.store = useStore()
    this.fileBindId = Date.now().toString()
    // 页面进入时自动获取证书列表
    this.initCertList()
  },
  methods: {
    // 初始化证书列表
    async initCertList() {
      this.isLoadingCert = true
      try {
        // 初始化WebSocket连接
        await this.xtxObject.initWebSocket()
        // 获取用户列表
        await this.xtxObject.SOF_GetUserList()
        // 等待一下，确保store已更新
        await this.$nextTick()
        // 获取证书列表
        const certList = this.store.state.XTXModel.ukeyList || []
        const filteredCertList = certList
        console.log('filteredCertList', filteredCertList);
        

        // 保存证书列表
        this.certList = filteredCertList
        
        if (filteredCertList.length > 0) {
          // 自动选择第一个证书
          const selectedCert = filteredCertList[0]
          this.form.certId = selectedCert.certid
          this.$message.success(`已加载 ${filteredCertList.length} 个证书，已自动选择：${selectedCert.name}`)
        } else {
          this.$message.warning('未找到可用证书，请确保已插入CA锁并安装了证书助手')
        }
      } catch (error) {
     console.error('请确保已安装证书助手并插入CA锁')
      } finally {
        this.isLoadingCert = false
      }
    },
    
    getSelectCertID() {
      if (!this.form.certId || this.form.certId === '') {
        this.$message.warning('请选择证书')
        return ''
      }
      return this.form.certId
    },
    
    async handleLogin() {
      const certId = this.getSelectCertID()
      if (!certId) {
        return
      }
      if (!this.form.passWd) {
        this.$message.warning('请输入密码')
        return
      }
      this.loading = true
      try {
        const result = await this.xtxObject.SOF_Login(certId, this.form.passWd)
        if (result) {
          this.$message.success('登录成功')
          // 登录成功后获取证书信息
          const newCertId = this.getSelectCertID()
          this.ExportExChangeUserCert(newCertId)
          // if (newCertId) {
          //   for(let i = 1; i <= 61; i++){
          //     await this.handleGetCertInfo(newCertId, i)
          //   }
          //   setTimeout(() => {
            
          //     console.log(this.certInfoArr[19]);
              
          //       // 证书获取完成后，按OID获取扩展信息（示例OID来源于xtxsync_demo.html）
          //   // await this.handleGetCertInfoByOid(newCertId, '2.16.840.1.113732.2')
          //   }, 5000);
          
          // }
        } else {
          this.$message.error('登录失败')
        }
      } catch (error) {
        console.error('登录错误:', error)
        this.$message.error('登录失败：' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },

    // 导出用户加密证书（Exchange），用于公钥加密
    async ExportExChangeUserCert(certId){
      console.log('--------导出用户加密证书（Exchange），用于公钥加密进入');
      
      try {
        const result = await this.xtxObject.SOF_ExportExChangeUserCert(certId)
        console.log(result);
              console.log('--------导出用户加密证书（Exchange），用于公钥加密结果');
        
        if (!result) {
          this.$message.error('导出用户加密证书失败')
          return
        }
        // 保存到表单，便于直接用于加密
        this.asymForm.cert = result
        this.$message.success('导出用户加密证书成功')
      } catch (e) {
        console.error('导出用户加密证书错误:', e)
        this.$message.error('导出用户加密证书失败：' + (e.message || '未知错误'))
      }
    },

    // 公钥加密（使用导出的Exchange证书）
    async handleAsymEncrypt() {
      if (!this.asymForm.plain) {
        this.$message.warning('请输入原文数据')
        return
      }
      if (!this.asymForm.cert) {
        this.$message.warning('请先导出并填充用户加密证书')
        return
      }
      this.asymLoading.encrypt = true
      try {
        const cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.asymForm.plain)
        if (!cipher) {
          this.$message.error('公钥加密失败')
          return
        }
        this.asymForm.cipher = cipher
        this.$message.success('公钥加密成功')
      } catch (error) {
        console.error('公钥加密错误:', error)
        this.$message.error('公钥加密失败：' + (error.message || '未知错误'))
      } finally {
        this.asymLoading.encrypt = false
      }
    },

    // 私钥解密（参考 test_SOF_PriKeyDecrypt）
    async handleAsymDecrypt() {
      const certId = this.getSelectCertID()
      if (!certId) return
      if (!this.asymForm.cipher) {
        this.$message.warning('请先输入或生成加密后的密文')
        return
      }
      this.asymLoading.decrypt = true
      try {
        const doBase64 = !!this.asymForm.base64Out
        const plain = doBase64
          ? await this.xtxObject.SOF_PriKeyDecryptEx(certId, this.asymForm.cipher)
          : await this.xtxObject.SOF_PriKeyDecrypt(certId, this.asymForm.cipher)
        if (!plain) {
          this.$message.error('私钥解密失败')
          return
        }
        this.asymForm.decrypted = plain
        this.$message.success('私钥解密成功')
      } catch (error) {
        console.error('私钥解密错误:', error)
        this.$message.error('私钥解密失败：' + (error.message || '未知错误'))
      } finally {
        this.asymLoading.decrypt = false
      }
    },



    async handleGetCertInfo(certId, type) {
      try {
        // 1. 先导出证书
        const cert = await this.xtxObject.SOF_ExportUserCert(certId)
        if (!cert) {
          this.$message.error('获取证书失败')
          return null
        }
        console.log('证书导出成功:', cert)
        // 2. 获取证书信息
        const certInfo = await this.xtxObject.SOF_GetCertInfo(cert, type)
        console.log('证书信息（type:', type, '）:', certInfo)
        setTimeout(() => {
          
        }, 5000);

        let obj = {
          type: type,
          certInfo: certInfo
        }
        this.certInfoArr.push(obj)
        // GetCertinfoByOid
        if (certInfo) {
          this.$message.success('获取证书信息成功')
          return certInfo
        } else {
          this.$message.warning('未获取到证书信息')
          return null
        }
      } catch (error) {
        console.error('获取证书信息错误:', error)
        this.$message.error('获取证书信息失败：' + (error.message || '未知错误'))
        return null
      }
    },

    async handleGetCertInfoByOid(certId, oid) {
      try {
        const cert = await this.xtxObject.SOF_ExportUserCert(certId)
        if (!cert) {
          this.$message.error('导出证书失败，无法获取OID信息')
          return null
        }
        const infoByOid = await this.xtxObject.SOF_GetCertInfoByOid(cert, oid)
        console.log('GetCertInfoByOid', oid, infoByOid)
        if (infoByOid) {
          this.$message.success('获取证书OID信息成功')
          return infoByOid
        } else {
          this.$message.warning('未获取到证书OID信息')
          return null
        }
      } catch (error) {
        console.error('GetCertInfoByOid 错误:', error)
        this.$message.error('获取证书OID信息失败：' + (error.message || '未知错误'))
        return null
      }
    },
    //  获取对称密钥
    async handleGetSymKey() {
      try {
        const encryptMethod = 0x00000401;
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod);
        
        if (setResult !== 0) {
          this.$message.error('设置加密算法失败!');
          return null;
        }
        console.log('加密算法设置成功: SM4_ECB');
        // 生成16位（字节）的对称密钥
        // 注意：这里传入的是字节数，16字节 = 128位
        const keyLength = 16;
        const symKey = await this.xtxObject.SOF_GenRandom(keyLength);
        
        if (!symKey || symKey === "") {
          this.$message.error('产生对称密钥失败!');
          return null;
        }
        
        console.log('对称密钥（Base64格式）:', symKey);
        this.$message.success('获取对称密钥成功');
        return symKey;
      } catch (error) {
        console.error('获取对称密钥错误:', error);
        this.$message.error('获取对称密钥失败：' + (error.message || '未知错误'));
        return null;
      }
    },
    // 填充对称密钥到表单
    async handleFillSymKey() {
      const symKey = await this.handleGetSymKey();
      if (symKey) {
        this.encryptForm.symKey = symKey;
      }
    },
    // 加密数据
    async handleEncrypt() {
      if (!this.encryptForm.symKey) {
        this.$message.warning('请先获取对称密钥');
        return;
      }
      if (!this.encryptForm.plainText) {
        this.$message.warning('请输入原文数据');
        return;
      }
      
      this.encryptLoading = true;
      try {
        // 先设置加密算法
        const encryptMethod = 0x00000401; // SM4_ECB
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod);
        if (setResult !== 0) {
          this.$message.error('设置加密算法失败!');
          return;
        }
        // 执行加密，参数顺序：key, data
        const cipherText = await this.xtxObject.SOF_SymEncryptData(this.encryptForm.symKey, this.encryptForm.plainText);
        
        if (!cipherText || cipherText === "") {
          this.$message.error('加密失败!');
          return;
        }
        
        this.encryptForm.cipherText = cipherText;
        this.$message.success('加密成功');
        console.log('加密后的密文:', cipherText);
      } catch (error) {
        console.error('加密错误:', error);
        this.$message.error('加密失败：' + (error.message || '未知错误'));
      } finally {
        this.encryptLoading = false;
      }
    },
    // 解密数据
    async handleDecrypt() {
      if (!this.encryptForm.symKey) {
        this.$message.warning('请先获取对称密钥');
        return;
      }
      if (!this.encryptForm.cipherText) {
        this.$message.warning('请输入加密后的密文');
        return;
      }
      
      this.decryptLoading = true;
      try {
        // 先设置加密算法
        const encryptMethod = 0x00000401; // SM4_ECB
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod);
        
        if (setResult !== 0) {
          this.$message.error('设置加密算法失败!');
          return;
        }
        
        // 执行解密，参数顺序：key, encryptedData
        const decryptedText = await this.xtxObject.SOF_SymDecryptData(this.encryptForm.symKey, this.encryptForm.cipherText);
        
        if (!decryptedText || decryptedText === "") {
          this.$message.error('解密失败!');
          return;
        }
        
        this.encryptForm.decryptedText = decryptedText;
        this.$message.success('解密成功');
        console.log('解密后的明文:', decryptedText);
      } catch (error) {
        console.error('解密错误:', error);
        this.$message.error('解密失败：' + (error.message || '未知错误'));
      } finally {
        this.decryptLoading = false;
      }
    },
    
    // 处理上传文件
    handleUploadDocument() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.pdf'
      input.onchange = (e) => {
        this.handleFileSelect(e)
      }
      input.click()
    },
    
    // 处理文件选择
    async handleFileSelect(event) {
      const file = event.target.files[0]
      if (!file || !this.validateFile(file)) return

      try {
        this.showUploadProgress(file)
        const uploadResult = await this.uploadFileWithChunks(file)
        this.handleUploadResult(uploadResult, file)
      } catch (error) {
        this.handleUploadError(error, file)
      }
    },
    
    // 验证文件
    validateFile(file) {
      const maxSize = 102400 * 1024 * 1024 // 10GB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10GB')
        return false
      }
      const allowedTypes = UPLOAD_CONSTANTS.SUPPORTED_FILE_TYPES.split(',')
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
      if (!allowedTypes.includes(fileExtension)) {
        this.$message.error('不支持的文件类型')
        return false
      }
      return true
    },
    
    // 显示上传进度
    showUploadProgress(file) {
      this.uploadProgress = {
        visible: true,
        percentage: 0,
        fileName: file.name,
        status: UPLOAD_CONSTANTS.STATUS.UPLOADING
      }
    },
    
    // 处理上传结果
    handleUploadResult(uploadResult, file) {
      if (uploadResult && uploadResult.success) {
        this.uploadProgress.status = UPLOAD_CONSTANTS.STATUS.SUCCESS
        this.uploadProgress.percentage = 100
        const fileId = uploadResult.fileId || uploadResult.id || ''
        if (fileId) {
          this.uploadedFiles.push({
            fileName: file.name,
            uploadTime: new Date().toLocaleString(),
            uploader: '当前用户',
            fileId: fileId
          })
        }
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.success(`文件 ${file.name} 上传成功`)
        }, 1000)
      } else {
        this.uploadProgress.status = UPLOAD_CONSTANTS.STATUS.ERROR
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.error(`文件上传失败: ${uploadResult?.message || '未知错误'}`)
        }, 1000)
      }
    },
    
    // 处理上传错误
    handleUploadError(error, file) {
      this.uploadProgress.status = UPLOAD_CONSTANTS.STATUS.ERROR
      setTimeout(() => {
        this.uploadProgress.visible = false
        this.$message.error(`文件上传失败: ${error.message || '未知错误'}`)
      }, 1000)
    },
    
    // 上传文件
    async uploadFileWithChunks(file) {
      let uploadedFileId = null
      const uploadResult = await doFileUpload(file, {
        fileBindId: this.fileBindId,
        onProgress: (progress) => {
          this.uploadProgress.percentage = Math.round(Number(progress) || 0)
        },
        onSuccess: (r) => {
          uploadedFileId = r.fileId || r.id || ''
        },
        onError: () => { }
      })
      if (uploadResult && uploadedFileId) {
        uploadResult.fileId = uploadedFileId
      }
      return uploadResult
    },
    
    // 删除文件
    handleDeleteFile(row) {
      this.$confirm('确定要删除这个文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.uploadedFiles.findIndex(item => item.fileId === row.fileId)
        if (index > -1) {
          this.uploadedFiles.splice(index, 1)
          this.$message.success('删除成功')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }

  }
}
</script>

<style scoped>
.credit-query-page {
  padding: 20px;
}

.page-card {
  min-height: 500px;
}

.card-header h2 {
  margin: 0;
  color: #333;
}

.page-content {
  padding: 20px 0;
}

.login-form {
  max-width: 500px;
}

.encrypt-form {
  max-width: 800px;
  margin-top: 20px;
}

.loading-tip {
  margin-top: 5px;
  color: #909399;
  font-size: 12px;
}

/* 文件上传区域样式 */
.upload-section {
  margin-top: 20px;
  max-width: 800px;
}

.upload-area {
  margin-bottom: 20px;
}

.el-upload__tip {
  margin-top: 10px;
  color: #909399;
  font-size: 12px;
}

.uploaded-files {
  margin-top: 10px;
}

.upload-progress-content {
  padding: 20px;
}

.upload-info {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-status {
  font-size: 14px;
}
</style>